import { render, staticRenderFns } from "./CardTypeNumTip.vue?vue&type=template&id=67075db8&scoped=true"
import script from "./CardTypeNumTip.vue?vue&type=script&lang=js"
export * from "./CardTypeNumTip.vue?vue&type=script&lang=js"
import style0 from "./CardTypeNumTip.vue?vue&type=style&index=0&id=67075db8&prod&lang=less&scoped=true"
import style1 from "./CardTypeNumTip.vue?vue&type=style&index=1&id=67075db8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67075db8",
  null
  
)

export default component.exports